"use client";

import { useState } from "react";
import { FAQ_ITEMS } from "./faq-data";
import type { FaqItem } from "./faq-data";

function FaqRow({ item }: { item: FaqItem }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-stone/30 last:border-b-0">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-start justify-between gap-4 py-5 text-left cursor-pointer bg-transparent border-none px-0"
        aria-expanded={open}
      >
        <span className="text-[15px] sm:text-base font-semibold text-charcoal leading-snug pr-2">
          {item.question}
        </span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`shrink-0 mt-0.5 text-text-muted transition-transform duration-200 ${open ? "rotate-180" : ""}`}
          aria-hidden="true"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      <div
        className={`grid transition-[grid-template-rows] duration-200 ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
      >
        <div className="overflow-hidden">
          <p className="text-sm sm:text-[15px] text-text-body leading-relaxed pb-5">
            {item.answer}
          </p>
        </div>
      </div>
    </div>
  );
}

export function FaqSection() {
  return (
    <div>
      {FAQ_ITEMS.map((item, i) => (
        <FaqRow key={i} item={item} />
      ))}
    </div>
  );
}
